<div class="row page-header">
    <div class="col-12">
        <h1>Weekly Scorecard <small>View scorecard information for the current week.</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()" style="margin-bottom: 10px">
        <li [ngbNavItem]="1" [destroyOnHide]="false" [hidden]="!canViewGoals">
            <a ngbNavLink>Goals</a>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false" [hidden]="!canViewHiring">
            <a ngbNavLink>Hiring</a>
        </li>
        <li [ngbNavItem]="3" [destroyOnHide]="false" [hidden]="!canViewAdmin">
            <a ngbNavLink>Separation/Discipline</a>
        </li>
        <li [ngbNavItem]="4" [destroyOnHide]="false" [hidden]="!canViewAdmin">
            <a ngbNavLink>Benefits</a>
        </li>
        <grid-export style="margin-left: 5px; margin-top: 5px" [grids]="exportGrids" [name]="'Scorecard'" [names]="exportGridNames">
        </grid-export>
    </ul>

    <div class="row" [hidden]="active !== 1">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="goalsGrid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="goalsGrid"
                            [canEdit]="canEditGoals"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="false"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="goalsGrid.filter"></action-toolbar-search>
                        <button
                            type="button"
                            class="btn btn-sm btn-secondary"
                            style="margin-left: auto"
                            (click)="showAll = !showAll; filterItems()"
                        >
                            {{ showAll ? 'Hide Archived' : 'Show Archived' }}
                        </button>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridGoals"
                        #gridGoals
                        appAutoSize
                        [padding]="73"
                        (initialized)="goalsGrid.initialize(gridGoals)"
                        [itemsSource]="goalsGrid.view"
                        [itemFormatter]="goalsGridItemFormatter"
                        (beginningEdit)="beginningEdit(gridGoals, $event)"
                        (cellEditEnded)="cellEditEnded(gridGoals, $event)"
                        (pasting)="pasting(gridGoals, $event)"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Who'" [binding]="'userId'" [dataMap]="allUserMap" [width]="75" [isReadOnly]="true">
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Metric'" [binding]="'name'" [width]="300" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="' '"
                            [binding]="'goalDirection'"
                            [dataMap]="goalDirectionMap"
                            [width]="70"
                            [align]="'center'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Goal'"
                            [binding]="'goal1'"
                            [width]="120"
                            [align]="'center'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Average'"
                            [binding]="'average'"
                            [width]="100"
                            [align]="'center'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Sum'"
                            [binding]="'sum'"
                            [width]="120"
                            [align]="'center'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        @for (month of weekCols; track month) {
                            <wj-flex-grid-column
                                [binding]="'weekValues.' + month"
                                [align]="'center'"
                                [header]="month"
                                [width]="110"
                                [isRequired]="false"
                            >
                                <!--<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                    <img src="resources/{{cell.item.country}}.png" />
                                    {{cell.item.country}}
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                                    <wj-combo-box [itemsSource]="countries" class="cell-editor" [(selectedValue)]="cell.value"
                                                  [isEditable]="false" [isRequired]="false" [placeholder]="'Select a Country'">
                                    </wj-combo-box>
                                </ng-template>-->
                            </wj-flex-grid-column>
                        }
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="gridGoals"></grid-selection-calculation>
                </div>
            </div>
        </div>
    </div>
    <div class="row" [hidden]="active !== 2">
        <div class="col-12">
            <h5 style="display: inline-block">Hiring Needs</h5>
            <action-toolbar-buttons
                style="display: inline-block; margin: 0 0 5px 15px"
                [grid]="hireNeedsGrid"
                [canEdit]="canEditHiring"
                [showAdd]="true"
                [showEdit]="true"
                [showDelete]="true"
            ></action-toolbar-buttons>
            <!--<grid-pdf-export style="margin-left:5px"
                             [grids]="[gridHireNeeds, gridOffers, gridNewHires, gridHires90, gridHires180]"
                             [name]="'Hiring'"
                             [names]="['Hiring Needs', 'Offers Made', 'New Hires - Past 7 Days', 'Hires Reaching 90 Days', 'Hires Reaching 180 Days']">
            </grid-pdf-export>
            <button class="btn btn-sm btn-secondary" style="margin-left:5px" (click)="printDoc(gridHireNeeds)" title="Print"><fa-icon [icon]="faPrint" [fixedWidth]="true"></fa-icon></button>-->
            <wj-flex-grid
                id="gridHireNeeds"
                #gridHireNeeds
                style="height: 350px"
                (initialized)="hireNeedsGrid.initialize(gridHireNeeds)"
                [itemsSource]="hireNeedsGrid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Position'" [binding]="'position'" [width]="'1.5*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Needs'" [binding]="'needs'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Applicants'" [binding]="'applicants'" [minWidth]="120" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Interviews'" [binding]="'interviews'" [minWidth]="120" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Offers Extended'" [binding]="'offers'" [minWidth]="120" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Referrals'" [binding]="'referrals'" [minWidth]="110" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Applications Rejected'"
                    [binding]="'applicationsRejected'"
                    [minWidth]="140"
                    [width]="'*'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Applications Under Review'"
                    [binding]="'applicationsUnderReview'"
                    [minWidth]="160"
                    [width]="'*'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Number of Screenings'"
                    [binding]="'screenings'"
                    [minWidth]="140"
                    [width]="'*'"
                ></wj-flex-grid-column>
            </wj-flex-grid>
        </div>
        <div class="col-lg-6 col-md-12">
            <h5 style="display: inline-block">Applicant Status</h5>
            <action-toolbar-buttons
                style="display: inline-block; margin: 0 0 5px 15px"
                [grid]="applicantStatusGrid"
                [canEdit]="canEditHiring"
                [showAdd]="true"
                [showEdit]="true"
                [showDelete]="true"
            ></action-toolbar-buttons>
            <wj-flex-grid
                id="gridApplicantStatus"
                #gridApplicantStatus
                style="height: 250px"
                (initialized)="applicantStatusGrid.initialize(gridApplicantStatus)"
                [itemsSource]="applicantStatusGrid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Candidate Name'" [binding]="'candidateName'" [width]="'1.5*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Position'" [binding]="'position'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Drug Test'" [binding]="'drugTest'" [dataType]="'Boolean'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Reference Check'"
                    [binding]="'referenceCheck'"
                    [dataType]="'Boolean'"
                    [minWidth]="120"
                    [width]="'*'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column header="VOE's" [binding]="'voes'" [dataType]="'Boolean'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Source of Application'"
                    [binding]="'sourceOfApplication'"
                    [minWidth]="140"
                    [width]="'1.5*'"
                ></wj-flex-grid-column>
            </wj-flex-grid>
        </div>
        <div class="col-lg-6 col-md-12">
            <h5 style="display: inline-block">Surveys</h5>
            <action-toolbar-buttons
                style="display: inline-block; margin: 0 0 5px 15px"
                [grid]="surveysGrid"
                [canEdit]="canEditHiring"
                [showAdd]="true"
                [showEdit]="true"
                [showDelete]="true"
            ></action-toolbar-buttons>
            <wj-flex-grid
                id="gridSurveys"
                #gridSurveys
                style="height: 250px"
                (initialized)="surveysGrid.initialize(gridSurveys)"
                [itemsSource]="surveysGrid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Survey Name'" [binding]="'name'" [width]="'1.5*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Number Sent Out'" [binding]="'numberSent'" [minWidth]="120" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Number Completed'"
                    [binding]="'numberCompleted'"
                    [minWidth]="130"
                    [width]="'*'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Number of Follow Ups'"
                    [binding]="'numberOfFollowUps'"
                    [minWidth]="140"
                    [width]="'*'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Number of Trainings'"
                    [binding]="'numberOfTrainings'"
                    [minWidth]="140"
                    [width]="'*'"
                ></wj-flex-grid-column>
            </wj-flex-grid>
        </div>
        <div class="col-lg-6 col-md-12">
            <h5 style="display: inline-block">Offers Made</h5>
            <action-toolbar-buttons
                style="display: inline-block; margin: 0 0 5px 15px"
                [grid]="offersGrid"
                [canEdit]="canEditHiring"
                [showAdd]="true"
                [showEdit]="true"
                [showDelete]="true"
            ></action-toolbar-buttons>
            <wj-flex-grid
                id="gridOffers"
                #gridOffers
                appAutoSize
                [minHeight]="200"
                (initialized)="offersGrid.initialize(gridOffers)"
                [itemsSource]="offersGrid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Position'" [binding]="'position'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Offer Date'" [binding]="'offerDate'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Expected Start Date'" [binding]="'startDate'" [width]="'*'"></wj-flex-grid-column>
            </wj-flex-grid>
        </div>
        <div class="col-lg-6 col-md-12">
            <h5>New Hires - Past 14 Days</h5>
            <wj-flex-grid
                id="gridNewHires"
                #gridNewHires
                style="height: 200px"
                (initialized)="newHiresGrid.initialize(gridNewHires)"
                [itemsSource]="newHiresGrid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Hire Date'" [binding]="'hireDate'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Status'" [binding]="'status'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Position'" [binding]="'position'" [width]="'*'"></wj-flex-grid-column>
            </wj-flex-grid>
            <h5>Hires Reaching 90 Days</h5>
            <wj-flex-grid
                id="gridHires90"
                #gridHires90
                style="height: 200px"
                (initialized)="hires90Grid.initialize(gridHires90)"
                [itemsSource]="hires90Grid.view"
                [itemFormatter]="hires90180GridItemFormatter"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Hire Date'" [binding]="'hireDate'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'90-Day Milestone'" [binding]="'date'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Reports To'" [binding]="'reportsTo'" [width]="'*'"></wj-flex-grid-column>
            </wj-flex-grid>
            <h5>Hires Reaching 180 Days</h5>
            <wj-flex-grid
                id="gridHires180"
                #gridHires180
                appAutoSize
                [minHeight]="200"
                (initialized)="hires180Grid.initialize(gridHires180)"
                [itemsSource]="hires180Grid.view"
                [itemFormatter]="hires90180GridItemFormatter"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Hire Date'" [binding]="'hireDate'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'180-Day Milestone'" [binding]="'date'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Reports To'" [binding]="'reportsTo'" [width]="'*'"></wj-flex-grid-column>
            </wj-flex-grid>
        </div>
    </div>
    <div class="row" [hidden]="active !== 3">
        <div class="col-lg-6 col-md-12">
            <h5 style="display: inline-block">Separated Employees - Past 14 Days</h5>
            <wj-flex-grid
                id="gridSeparated"
                style="margin-top: 5px"
                #gridSeparated
                appAutoSize
                (initialized)="separatedGrid.initialize(gridSeparated)"
                [itemsSource]="separatedGrid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'2*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Separation Date'" [binding]="'separationDate'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Separation Reason'" [binding]="'separationReason'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Position'" [binding]="'position'" [width]="'*'"></wj-flex-grid-column>
            </wj-flex-grid>
        </div>
        <div class="col-lg-6 col-md-12">
            <h5>Disciplinary Actions - Past 14 Days</h5>
            <wj-flex-grid
                id="gridDiscipline"
                #gridDiscipline
                style="height: 400px"
                (initialized)="disciplineGrid.initialize(gridDiscipline)"
                [itemsSource]="disciplineGrid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'2*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Code'" [binding]="'code'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Date'" [binding]="'date'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="'3*'"></wj-flex-grid-column>
            </wj-flex-grid>
            <h5>Disciplinary Follow Ups This Month</h5>
            <wj-flex-grid
                id="gridDisciplineFollowUp"
                #gridDisciplineFollowUp
                appAutoSize
                (initialized)="disciplineGridFollowUp.initialize(gridDisciplineFollowUp)"
                [itemsSource]="disciplineGridFollowUp.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'1.5*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Code'" [binding]="'code'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Follow Up Date'" [binding]="'followUpDate'" [width]="'1.5*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Reports To'" [binding]="'reportsTo'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="'2.5*'"></wj-flex-grid-column>
            </wj-flex-grid>
        </div>
    </div>
    <div class="row" [hidden]="active !== 4">
        <div class="col-lg-6 col-md-12">
            <h5>Eligible for Benefits this Month</h5>
            <wj-flex-grid
                id="gridBenefitEligible"
                #gridBenefitEligible
                appAutoSize
                (initialized)="benefitEligibleGrid.initialize(gridBenefitEligible)"
                [itemsSource]="benefitEligibleGrid.view"
                (cellEditEnded)="benefitEligibleGridCellEditEnded(gridBenefitEligible, $event)"
                [itemFormatter]="benefitEligibleGridFormatter"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Effective Date'"
                    [binding]="'effectiveDate'"
                    [width]="'*'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Hire Date'" [binding]="'hireDate'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="'3*'"></wj-flex-grid-column>
            </wj-flex-grid>
        </div>
        <div class="col-lg-6 col-md-12">
            <h5>Benefits and Counts at Month Start</h5>
            <wj-flex-grid
                id="gridBenefitCounts"
                #gridBenefitCounts
                appAutoSize
                (initialized)="benefitCountsGrid.initialize(gridBenefitCounts)"
                [itemsSource]="benefitCountsGrid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Benefit Type'" [binding]="'benefitType'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'#EE on Plan'" [binding]="'eeOnPlan'" [width]="'*'"></wj-flex-grid-column>
            </wj-flex-grid>
        </div>
    </div>
</div>
